import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import {
  fetchIBSCProgress,
  selectIBSCData,
  selectIBSCStatus,
} from '../ibsc.slice'

export function useIBSCProgress() {
  let dispatch = useAppDispatch()
  let data = useAppSelector(selectIBSCData)
  let status = useAppSelector(selectIBSCStatus)

  let isLoading = status === 'pending' || status === 'uninitialized'
  let isError = status === 'rejected'
  let isSuccess = status === 'fulfilled'

  useEffect(() => {
    if (status === 'uninitialized') {
      dispatch(fetchIBSCProgress())
    }
  }, [status, dispatch])

  return {
    data,
    status,
    isLoading,
    isError,
    isSuccess,
    refetch: () => dispatch(fetchIBSCProgress()),
  }
}
